<template>
  <div class="form-group row mt-3">
    <label class="col-sm-2 text-sm-right" v-if="autoCompleteIsVisible(type)">Sigla Orgão:</label>
    <auto-complete-comp
      :key="autocompleteKey"
      v-if="autoCompleteIsVisible(type)"
      class="col-md-4 col-sm-10 mb-3"
      :isAsync="true"
      :url="autoCompleteSiglaOrgao.url"
      mutation="MUT_FILTRO_DESTINATARIO_DEPARTAMENTO"
      keyAttrName="estruturaID"
      valueAttrName="siglaEstrutura"
      :valor="{codigoHierarquia: filtro.codigoHierarquia}">
    </auto-complete-comp>

    <label class="col-sm-2 text-sm-right">Sigla Departamento:</label>
    <div :class="autoCompleteIsVisible(type) ? 'col-md-3 col-sm-11 mb-3' : 'col-md-4 col-sm-11 mb-3'">
      <input
        type="text"
        class="form-control"
        id="inputDepartamento"
        placeholder="informe o departamento"
        v-model="filtro.siglaEstrutura"
        :disabled="habilitarCampos == 1"
      />
    </div>

    <label class="col-sm-2 text-sm-right">Descrição Departamento:</label>
    <div :class="autoCompleteIsVisible(type) ? 'col-md-4 col-sm-11 mb-3' : 'col-md-3 col-sm-11 mb-3'">
      <input type="text"
             class="form-control"
             id="nomeEstrutura"
             placeholder="informe a descrição do departamento"
             @change="alterarFiltro"
             v-model="filtro.nomeEstrutura"
             :disabled="habilitarCampos === 1"
      >
    </div>

    <label class="col-sm-2 text-sm-right">Nome Gestor:</label>
    <div :class="autoCompleteIsVisible(type) ? 'col-md-3 col-sm-11 mb-3' : 'col-md-4 col-sm-11 mb-3'">
      <input
        type="text"
        class="form-control"
        id="inputGestor"
        placeholder="informe o nome do gestor"
        v-model="filtro.nomeGestor"
        :disabled="habilitarCampos == 1"
      />
    </div>

    <label class="col-sm-2 text-sm-right">Cidade:</label>
    <div :class="autoCompleteIsVisible(type) ? 'col-md-4 col-sm-11 mb-3' : 'col-md-3 col-sm-11 mb-3'">
      <input
        type="text"
        class="form-control"
        id="inputCidade"
        placeholder="informe a cidade"
        v-model="filtro.cidade"
        :disabled="habilitarCampos == 1"
      />
    </div>

    <div class="col-sm-12">
      <div class="row btnAcoes">
        <div class="col-1"></div>
        <button class="btn btn-outline-success" @click.prevent="() => consultar()"> Pesquisar</button>
        <button class="btn btn-outline-danger" @click.prevent="limpar"> Limpar</button>
      </div>
    </div>
  </div>
</template>

<script>
import DadosFixosService from '@/services/DestinatarioService'
import autoCompleteComp from '@/components/autocomplete/AutoCompleteComp'
import { componentIsVisible, rules } from '@/uteis/action/permissao'

import { DISTRIBUIR, EXPEDIR, isExpedicao } from '@/uteis/action/tramite'
import eventBus from '@/uteis/eventBus'

export default {
  components: {
    autoCompleteComp
  },

  props: {
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String },
    acceptUserDepartamento: { required: false, type: Boolean, default: false }
  },

  data () {
    return {
      autoCompleteSiglaOrgao: {
        url: '/d0593/pae-back/v1/participantes/estrutura',
        evento: 'filtroDepartamentoDestinatario'
      },
      filtro: {
        codHierarquia: null,
        siglaEstrutura: null,
        nomeGestor: null,
        cidade: null,
        idDepartamento: null,
        nomeEstrutura: null,
        range: 5
      },
      columns: [
        [
          { key: 'nomeEstrutura', title: 'Nome' },
          { key: 'siglaEstrutura', title: 'Sigla' },
          { key: 'tipoContatoExterno', title: 'Tipo', converter: 'tipoContatoExterno' }
        ], [
          { key: 'estruturaID', title: 'Identificador' },
          { key: 'cidadeEstado', title: 'Cidade' }
        ], [
          { key: 'nomeUsuario', title: 'Gestor' },
          { key: 'telefone', title: 'Telefone' }
        ]
      ],
      disabled: 1,
      type: EXPEDIR,
      autocompleteKey: true
    }
  },

  created () {
    this.service = new DadosFixosService()
    const { DISTRIBUIR_PROTOCOLO } = rules
    if (componentIsVisible(DISTRIBUIR_PROTOCOLO)) {
      this.type = DISTRIBUIR

      this.service.buscarEstruturas({
        filtro: this.$store.getters.getDadosSessao.sessao.siglaOrgao
      }).then((resp) => {
        const orgao = resp[0]
        console.log(orgao)
        const codHierarquia = orgao.codigoHierarquia
        this.$store.commit('MUT_FILTRO_DESTINATARIO_DEPARTAMENTO', orgao)
        this.filtro = { ...this.filtro, codHierarquia }
        this.consultar()
      })
    }

    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.consultar(numeroPagina)
    })

    eventBus.$on(this.autoCompleteSiglaOrgao.evento, (orgao) => {
      this.filtro = {
        ...this.filtro,
        codHierarquia: orgao.codigoHierarquia
      }
    })
    if (!this.acceptUserDepartamento) {
      this.filtro = { ...this.filtro, idDepartamento: this.$store.getters.getDadosSessao.sessao.idDepartamento }
    }
  },

  destroyed () {
    eventBus.$off(this.autoCompleteSiglaOrgao.evento)
  },

  methods: {
    autoCompleteIsVisible (text) {
      return isExpedicao(text)
    },

    alterarFiltro () {
      const { codigoHierarquia } = this.$store.state.filtroDestinatario
      this.filtro = { ...this.filtro, codigoHierarquia }
    },

    consultar (page = 1) {
      this.filtro = {
        ...this.filtro,
        offset: page
      }
      console.log(this.filtro)
      this.service.buscarDepartamento(this.filtro).then(res => {
        const departamentos = res.data.data.map((departamento) => {
          return {
            tipoContatoExterno: 'Poder Executivo Estadual',
            ...departamento,
            cidadeEstado: `${departamento.estado} / ${departamento.cidade}`
          }
        })
        eventBus.$emit(this.eventBusDataName, {
          data: departamentos,
          pagination: res.data.pagination,
          id: 'estruturaID',
          columns: this.columns
        })
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      this.filtro = {
        ...this.filtro,
        siglaEstrutura: null,
        nomeGestor: null,
        cidade: null,
        nomeEstrutura: null
      }

      const { EXPEDIR_PROTOCOLO } = rules
      if (componentIsVisible(EXPEDIR_PROTOCOLO)) {
        this.filtro = {
          ...this.filtro,
          codHierarquia: null
        }
        this.$store.commit('MUT_FILTRO_DESTINATARIO_DEPARTAMENTO', {})
        this.autocompleteKey = !this.autocompleteKey
      }
      this.consultar()
    }

  },
  computed: {
    habilitarCampos () {
      let retorno = 0
      if (!this.filtro.codHierarquia) {
        retorno = 1
      } else {
        retorno = 0
      }
      return retorno
    }
  }
}
</script>
